module.exports = __webpack_public_path__ + "static/media/signature-foods-logo.e6de6605.jpg";